import { Box, CircularProgress, Container, Link, Typography } from "@mui/material";
import {
	AccessTime,
	CloudDownload,
	Description,
	Info,
	NotificationsActiveRounded,
	ReportProblem,
	Videocam,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { getButtons } from "../database/API";
import { styled } from "@mui/material";

const InfoCard = styled(Link)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	textAlign: "center",
	gap: theme.spacing(1),
	width: 220,
	maxWidth: "100%",
	padding: theme.spacing(2.5, 2),
	borderRadius: 24,
	backgroundColor: "white",
	boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
	cursor: "pointer",
	textDecoration: "none",
	transition: "0.2s",
	[theme.breakpoints.down("sm")]: {
		width: "100%",
		maxWidth: 320,
		flexDirection: "row",
		textAlign: "left",
		padding: theme.spacing(1.5, 2),
	},
	"&:hover": {
		transform: "translateY(-4px)",
		boxShadow: "0 10px 24px rgba(0, 0, 0, 0.18)",
	},
}));

const IconBadge = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
	width: 64,
	height: 64,
	borderRadius: "50%",
	backgroundColor: theme.palette.background.default,
	[theme.breakpoints.down("sm")]: {
		width: 48,
		height: 48,
	},
}));

const InfoImportant = (props) => {
	const [buttons, setButtons] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const get = async () => {
			const { buttons } = await getButtons();
			setButtons(buttons);
			setLoading(false);
		};
		get();
	}, []);

	const renderIcon = (icon) => {
		const iconProps = {
			sx: {
				fontSize: { xs: 26, sm: 32 },
				fill: (theme) => theme.palette.third.main,
			},
		};
		switch (icon) {
			case "campana":
				return <NotificationsActiveRounded {...iconProps} />;
			case "descarregar":
				return <CloudDownload {...iconProps} />;
			case "document":
				return <Description {...iconProps} />;
			case "rellotge":
				return <AccessTime {...iconProps} />;
			case "info":
				return <Info {...iconProps} />;
			case "alerta":
				return <ReportProblem {...iconProps} />;
			case "video":
				return <Videocam {...iconProps} />;
			default:
				return null;
		}
	};

	return (
		<Container maxWidth={buttons.length >= 4 ? "xl" : "lg"}>
			<Box
				display="flex"
				flexWrap="wrap"
				justifyContent="center"
				alignItems="stretch"
				gap={{ xs: 1.5, sm: 3 }}
				px={{ xs: 2, sm: 0 }}
				mb={{ xs: 4, sm: 6 }}
			>
				{loading ? (
					<CircularProgress />
				) : (
					buttons?.map((item) => (
						<InfoCard
							key={item.id}
							href={
								item.url
									? item.url
									: "https://api.sinapsisberga.cat/storage/" +
									  item.file
							}
							target="_blank"
							rel="noopener noreferrer"
						>
							<IconBadge>{renderIcon(item.icon)}</IconBadge>
							<Box>
								<Typography
									variant="h4"
									sx={{ fontSize: { xs: "0.85rem", sm: "0.95rem" } }}
								>
									{item?.nom}
								</Typography>
								{item?.subtitol && (
									<Typography
										variant="body1"
										sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}
									>
										{item.subtitol}
									</Typography>
								)}
							</Box>
						</InfoCard>
					))
				)}
			</Box>
		</Container>
	);
};

export default InfoImportant;
